"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.advanced-prompts.disabled': 'Funkcja zaawansowanych promptów nie jest dostępna w Twoim obecnym planie.',
};
